export var ExhibitionistWidgetType = /*#__PURE__*/ function(ExhibitionistWidgetType) {
    ExhibitionistWidgetType["TALL"] = "tall";
    ExhibitionistWidgetType["STRIP"] = "strip";
    return ExhibitionistWidgetType;
}({});
export var ExhibitionistViewMode = /*#__PURE__*/ function(ExhibitionistViewMode) {
    ExhibitionistViewMode["TORPEDO"] = "torpedo";
    ExhibitionistViewMode["SLIDESHOW"] = "slideshow";
    return ExhibitionistViewMode;
}({});
export var ExhibitionistSlideFitMode = /*#__PURE__*/ function(ExhibitionistSlideFitMode) {
    ExhibitionistSlideFitMode["FIT"] = "fit";
    ExhibitionistSlideFitMode["COVER"] = "cover";
    return ExhibitionistSlideFitMode;
}({});
export var GallectionSourceType = /*#__PURE__*/ function(GallectionSourceType) {
    GallectionSourceType["FEATURED_GALLERY"] = "featured_gallery";
    GallectionSourceType["NEWEST"] = "newest";
    GallectionSourceType["GALLERY"] = "gallery";
    GallectionSourceType["COLLECTION"] = "collection";
    GallectionSourceType["PRIVATE_COLLECTION"] = "private_collection";
    GallectionSourceType["ADOPTABLE_BOUGHT"] = "adoptable_bought";
    GallectionSourceType["ADOPTABLE_FOR_SALE"] = "adoptable_for_sale";
    return GallectionSourceType;
}({});
export var GallectionSortOrder = /*#__PURE__*/ function(GallectionSortOrder) {
    GallectionSortOrder["NEWEST"] = "newest";
    GallectionSortOrder["POPULAR"] = "popular";
    return GallectionSortOrder;
}({});

//# sourceMappingURL=types.js.map